import React from 'react';

import "./styles.scss";

export const AlternativeBackground = ({children}) => {
    return (
        <div className="alternative-background">
            {children}
        </div>
    );
};
